import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebClientService } from "../../../../services/webclient-settings.service";
import { ComponentService } from "../../../../services/component.service";
import { DepositAddressWarningModalComponent } from "../../../deposit-address-warning-modal/deposit-address-warning-modal.component";
/**
 * End Component
 */
let EndSellComponent = class EndSellComponent {
    constructor(httpClient, route, sanitizer, themeService, webSettingsService, compService) {
        this.httpClient = httpClient;
        this.route = route;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.compService = compService;
        this.qrObject = {};
        this.status = 'registred_user';
        this.userData = {};
        this.textColor = '';
        this.mainColor = '';
        this.outcome = null;
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.errorColor = '';
        this.showData = false;
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.userType = this.userData.user_type_id.type;
        this.status = this.userType + '_user';
        this.isUser = false;
        this.sub = this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.outcome = params['outcome'];
        });
        this.webSettingsService.getSettings().subscribe(data => {
            if (this.webSettingsService.applySettings('SELL.DEPOSIT_ADDRESS_WARNING_POPUP.VISIBLE')) {
                this.compService.openModal(DepositAddressWarningModalComponent, null, () => {
                    this.showData = true;
                });
            }
            else {
                this.showData = true;
            }
        });
        this.httpClient.post('market/order/getpaymentslip', {
            order_id: this.orderId
        }).subscribe((data) => {
            this.qrObject = data;
        });
    }
};
EndSellComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: ComponentService }
];
EndSellComponent = __decorate([
    Component({
        selector: 'ecd-end',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./end.component.html")).default
    })
], EndSellComponent);
export { EndSellComponent };
